<template>
  <div id="app">
    <div v-if = "false" class = "debug-var">
    </div>

    <div v-if = "editorConfig.isShowingAlphaVersionBanner && isInEditor" class = "notification">
      <h1>Versión Beta</h1>
      <h2>Estamos afinando la herramienta <br/> Puedes encontrar aún cosas que no funcionan como debería. ¡Haz una copia del código en tu dispositivo siempre! <br />Si tienes alguna sugerencia, escribenos a <strong>programalaplaza@gmail.com</strong></h2>
      <button v-on:click = "acceptAlphaVersion" class = "btn btn-bg-colored">Entendido</button>
    </div>

    <!--
    <div v-if = "environment === 'development'" class = "debug main-shadow">
      <h1>debug panel</h1>
      <div class = "links">
        <router-link :to="{ name: 'Home', params: {} }">Home</router-link>
        <router-link :to="{ name: 'Editor.create' }">Editor.create</router-link>
        <router-link :to="{ name: 'Editor.load', params: { projectId: 'llalalaa-lalalal-lalll' }}">Editor.load</router-link>
        <router-link :to="{ name: 'Embed', params: { projectId: '32afd152-80cc-437e-b916-84367334bcd7' }}">Embed</router-link>
        <router-link :to="{ name: 'User', params: {} }">User</router-link>
        <router-link :to="{ name: 'Gallery', params: { page: 1 }}">Gallery</router-link>
        <router-link :to="{ name: 'ProjectPlayer' }">ProjectPlayer</router-link>
        <ul class = "color-selector">
          <button v-on:click = "changeColor" class = "white"></button>
          <button v-on:click = "changeColor" class = "black"></button>
        </ul>
      </div>
    </div>
    -->

    <div class = "app-container">
      <toolbar v-if = "!isInProjectPlayer"></toolbar>
      <transition name = "slidehorizontal" mode = "out-in">
        <editor-side-menu v-if = "editorConfig.isShowingSideMenu"></editor-side-menu>
      </transition>
      <transition name = "slidevertical" mode = "out-in">
        <router-view class = "pages"/>
      </transition>
    </div>

    <!-- help -->
    <b-modal :active.sync="editorConfig.isShowingHelp" has-modal-card>
      <editor-tips></editor-tips>
    </b-modal>

    <!-- sign in -->
    <b-modal :active.sync="editorConfig.isShowingAuthDecider">
      <auth-decider v-bind:is-modal="true"></auth-decider>
    </b-modal>

    <!-- register -->
    <b-modal :active.sync="editorConfig.isShowingRegister">
      <register-user v-bind:is-modal="true" ></register-user>
    </b-modal>

    <!-- login -->
    <b-modal :active.sync="editorConfig.isShowingLogin" >
      <login-user v-bind:is-modal="true"></login-user>
    </b-modal>

  </div>
</template>

<script>
import config from './api/config'
import Toolbar from './components/UI/Toolbar'
import AuthDecider from './components/Login/AuthDecider'
import RegisterUser from './components/Login/RegisterUser'
import LoginUser from './components/Login/LoginUser'
import EditorTips from './components/Editor/EditorTips'
import EditorSideMenu from './components/Editor/EditorSideMenu'

export default {
  name: 'App',
  components: {
    Toolbar,
    AuthDecider,
    RegisterUser,
    LoginUser,
    EditorTips,
    EditorSideMenu
  },
  methods: {
    resize: function () {
      let isMobile = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/"/g, '') === 'mobile'
      this.$store.commit('setEditorConfigProperty', {'isMobile': isMobile})
    },
    getAlphaVersion: function () {
      let accepted = localStorage.getItem('acceptAlphaVersion')

      let showBanner = true
      if (accepted === 'true') showBanner = false

      this.$store.commit('setEditorConfigProperty', {'isShowingAlphaVersionBanner': showBanner})
    },
    acceptAlphaVersion: function () {
      this.$store.commit('setEditorConfigProperty', {'isShowingAlphaVersionBanner': false})
      localStorage.setItem('acceptAlphaVersion', 'true')
    },
    getClassForRoute: function () {
      // if route name is in editor => not scrollable
      if (this.$route.name.includes('Editor')) {
        return 'not-scrollable'
      }
    }
  },
  computed: {
    environment: function () {
      return config.environment
    },
    state: function () {
      return this.$store.state
    },
    editorConfig () {
      return this.$store.state.editorConfig
    },
    isInEditor: function () {
      return this.$route.name === 'Editor' || this.$route.name === 'Editor.create' || this.$route.name === 'Editor.created' || this.$route.name === 'Editor.example' || this.$route.name === 'Editor.load'
    },
    isInProjectPlayer: function () {
      return (this.$route.name === 'ProjectPlayer' || this.$route.name === 'Mando')
    }
  },
  created () {
    this.resize()
    window.addEventListener('resize', () => {
      this.resize()
    })
    this.getAlphaVersion()
  }
}
</script>

<!--
Anything we put here will be global
I think is better practice to take all the global styles outside
I think is a good practice to put general stuff in the main.less and
specific stuff in each module

NOTE: the main style has to be imported only once here. In the rest
of the modules we only reference it. Otherwise we would import it
countless times
@import (reference) "./assets/styles/main.less";
-->
<style>
/*
@import url('https://fonts.googleapis.com/css?family=Roboto|Roboto+Mono|Roboto+Slab');
@import url('https://fonts.googleapis.com/css?family=Source+Code+Pro:200,300,400,500,600,700,900');
*/
@import url('https://fonts.googleapis.com/icon?family=Material+Icons');
@import url('https://fonts.googleapis.com/css?family=Open+Sans:400,700');
@import url('https://fonts.googleapis.com/css?family=Roboto:100,200,300,400,500,600,700');

@import url('https://fonts.googleapis.com/css?family=Share+Tech|Share+Tech+Mono');

</style>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

$green: #2fe67c;
$turquoise: #2D9CDB;
$yellow: #FFE066;
$red: #ED225D;

$primary: #2fe67c;
// $link: $green;
$family-sans-serif: "Open Sans", sans-serif;
$family-primary: $family-sans-serif;

$colors: (
  "white": ($white, $black),
  "black": ($black, $white),
  "light": ($light, $light-invert),
  "dark": ($dark, $dark-invert),
  "primary": ($primary, $primary-invert),
  "info": ($info, $info-invert),
  "success": ($green, $success-invert),
  "warning": ($yellow, $warning-invert),
  "danger": ($red, $danger-invert),
);

$desktop: 800px;
// $tablet: 800px;

@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>

<style lang = "less">
@import (reference) "./assets/styles/main.less";

/*
TODO
use reset.css or similar
*/

/*********************************
general styles move to main.less when it will
get bigger, here for convience
 */

html {
  overflow: auto;
}

.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

body:before {
  content: "desktop";
  display: none;
}

label.label.mandatory::after {
    content: "*";
    color: @accentColor;
}

@media (max-width: @breakPoint) {
  body:before {
    content: "mobile";
  }
}

* {
  margin: 0;
  padding: 0;
  // color: @primaryTextColor;
  box-sizing: border-box;
}

h1, h2, h3, p {
  padding: 0;
  margin: 0;
}

section {
  .container {
    width: 100%;
    max-width: 920px;
    margin: 0 auto;
    padding: 50px 20px;
  }

  .container-full {
    max-width: 1600px;
    margin: 0 auto;
    padding: 20px;
  }
}

.label {
  // border-bottom: 3px solid @accentColor;
}

.modal-wrapper {
  width: 640px;
  margin: 0 auto;
}

.modal-content, .modal-card {
  width: unset;
}

.modal .animation-content .modal-card {
    margin: 0 20px;
}

.modal-card {
  .font-code;

  border-radius: 3px;

  header, footer {
    background: @backgroundColor;
    border: 0px;
    border-radius: 0px;
  }

  footer {
    justify-content: flex-end;
  }

  p.modal-card-title {
    max-width: 351px;
    line-height: 1.3em;
    text-decoration-line: underline;
    text-decoration-style: initial;
    text-decoration-color: @accentColor;
  }

  .aux-links {
    margin-top: 15px;
  }

  &.with-border {
    border: 2px solid #2fe67c;
  }
}
footer.modal-card-foot{
  justify-content: flex-end;
}

.tabs {
  font-family: 'Share Tech';

  &.is-boxed a {
    background: #efefef;
    border-radius: 0px;
  }

  .is-active {
    span {
      color: black;
      border-bottom: 2px solid #2fe67c;
    }
  }
}

.tabs li.is-active a {
  border-bottom-color: @accentColor;
  color: @accentColor;
}

input {
  box-shadow: none !important;
  border: 0px solid black !important;
  border-radius: 0px !important;
  background: #e9e9e9 !important;
  border-bottom: 1px solid white !important;
}

::placeholder {
  color: #555 !important;
}

.main-shadow {
  .main-shadow-mixin;
}

ul {
  list-style-type: none;
  margin: 0;
  padding: 0;

  &.horizontal {
    li {
      display: inline-block;
    }
  }
}

.btn {
  // .font_code;
  font-weight: 500;
  font-size: 1.2em;
  background: transparent;
  color: @primaryTextColor;
  border: 0px;
  border-radius: 1px;
  padding: 8px 10px;
  margin: 5px;
  outline: none;
  cursor: pointer;

  &::-moz-focus-inner {
    border: 0;
  }

  &.btn-border-colored {
    border: 2px solid @accentColor;
    padding: 5px 8px;
    color: @accentColor;

    &:hover {
      background: lighten(@accentColor, 10%);
    }

    &:active {
      background: darken(@accentColor, 10%);
    }
  }

  &.btn-small {
    font-size: 0.8em;
  }

  &.btn-no-margin {
    margin: 0px !important;
  }

  &.btn-bg-colored {
    background: @accentColor;

    &:hover {
      background: lighten(@accentColor, 10%);
    }

    &:active {
      background: darken(@accentColor, 10%);
    }
  }

   &.btn-bg-transparent {
    background: transparent;

    &:hover {
      background: lighten(@accentColor, 10%);
    }

    &:active {
      background: darken(@accentColor, 10%);
    }
  }

  &.btn-colored {
    color: @accentColor;
  }

  &.btn-light {
    color: @secondaryTextColor;

    &:hover {
      color: fade(@secondaryTextColor, 20%) !important;
    }

    &:active {
      color: @secondaryTextColor !important;
    }
  }

  &.btn-left-icon {
    display: flex;
    align-items: center;

    .material-icons {
      margin-right: 5px;
    }
    .text-in-btn{
      align-self: center;
      width: 90%;
      text-align: center;
    }
  }

  &.btn-right-icon {
    display: flex;
    align-items: center;

    .material-icons, .icon {
      margin-left: 5px;
    }
  }

  &.btn-squared {
    width: 32px;
    height: 32px;
    padding: 5px !important;
  }

  &.btn-round {
    border-radius: 41px;
    padding: 5px 12px;
  }

  &.is-fullwidth {
    width: 100%;
  }
}

.disabled {
  opacity: 0.5;
  pointer-events: none;
}

/********************************* app styles **/

#app {
  font-family: 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: @primaryTextColor;
  background: @backgroundColor;
}

h1, h2, h3, h4, .btn {
  font-family: 'Share Tech', monospace;
}

.dotted {
  border-bottom: 3px dotted;
}

.debug {
  z-index: 12;
  position: fixed;
  right: 0;
  bottom: 10px;
  background: @backgroundColor;
  font-size: 0.8em;

  h1 {
    background: @accentColor;
    font-size: 1em;
    padding: 10px;
  }

  .links {
    a {
      display: block;
      padding: 2px 5px;
      color: black;
    }
  }
}

div.modal {
  position: fixed;
  z-index: 30;
}

div.modal div.animation-content {
  z-index: 100;
}

.dropdown {
  &.is-active {
    background: #232323;

    button { color: @accentColor; }
    button:hover { background: transparent; }
  }

  button:hover {
    background: #ffffff22;
  }

  .dropdown-menu {
    padding-top: 0;
  }

  button {
    height: 56px;
    margin: 0px;
    padding: 12px;
  }

}

.dropdown-content {
  background: #232323;
  border-radius: 0 0 2px 2px;
  color: white;

  .dropdown-item {
    display: flex;
    color: white;
    a { color: white; width: 100%; }
    .icon { margin-right: 10px; }
  }

  .group {
    margin: 15px;
  }

  .explanation {
    justify-content: center;
    color: #8e8e8e;
    text-align: center;
  }

  .header {
    color: @accentColor;
    user-select: none;

    &:hover {
      background: transparent !important;
    }
  }

  .dropdown-item:hover {
    background: @accentColor;
    a { color: black; }
  }
}

.button {
  &.is-success {
    background-color: @accentColor;
    border-color: transparent;
    color: @primaryTextColor;
  }
}

.menu-option {
  display: flex !important;
  align-items: center;

  .icon {
    margin-right: 10px;
  }
}

.tooltip.is-top.is-primary::before {
  border-top: 5px solid @accentColor;
}

.tooltip::after {
  border-radius: 1px;
}

.tooltip.is-top::after, .tooltip.is-primary::after {
  background: @accentColor;
  color: @primaryTextColor;
}

.control {
  font-size: 1em;
  background: transparent;
  color: @primaryTextColor;

  &.left .label {
    border-radius: 2px 0 0 2px;
  }

  &.right .label {
    border-radius: 0 2px 2px 0;
  }
}

.not-scrollable {
  overflow: hidden !important;
}

.fadeopacity-enter-active, .fadeopacity-leave-active {
  transition: all 0.3s ease-in-out;
}
.fadeopacity-enter, .fadeopacity-leave-active {
  opacity: 0;
}

.slidevertical-enter-active, .slidevertical-leave-active {
  transition: all 225ms ease-in-out;
}
.slidevertical-enter, .slidevertical-leave-active {
  opacity: 0;
  transition: all 225ms ease-in-out;
  transform: translate3d(0px, 20px, 20px);
}

.slidehorizontal-enter-active, .slidehorizontal-leave-active {
  transition: all 0.3s ease-in-out;
}
.slidehorizontal-enter, .slidehorizontal-leave-active {
  opacity: 0;
  transition: all 0.3s ease-in-out;
  transform: translate3d(-100px, 0px, 100px);
}

.ace_gutter {
  background: transparent !important;
  color: #cfcfcf !important;
}

.debug-var {
  position: absolute;
  top: 0;
  right: 0;
  width: 500px;
  padding: 10px;
  background: #000b;
  color: white;
  z-index: 123;
  pointer-events: none;
}

</style>



// WEBPACK FOOTER //
// src/App.vue